import BaseClient from '@/app/model/api/response/baseApiClient'

class RecordDetailApi extends BaseClient {
  public getRecordDetail (id: string, date: number) {
    const path = '/v1/planting-records/' + id + '/' + date
    const url = new URL(process.env.VUE_APP_API_URL + path)

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new RecordDetailApi()
